<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
	page: {
		title: 'Log in',
		meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
	},
	components: { Layout },
	data() {
		return {
			username: '',
			password: '',
			authError: null,
			tryingToLogIn: false,
			isAuthError: false,
		}
	},
	computed: {
		placeholders() {
			return process.env.NODE_ENV === 'production'
				? {}
				: {
						username: '',
						password: '',
				  }
		},
	},
  	mounted() {
    	if (typeof this.$route.query.token !== 'undefined') {
			this.tryToLogIn()
		}
		else {
			window.location.href = "https://www.lavillecasa.com.br/loginnewgiftlist";
		}
  	},	
	methods: {
		...authMethods,
		// Try to log the user in with the username
		// and password they provided.
		tryToLogIn() {
			var self = this;
			this.tryingToLogIn = true
			// Reset the authError if it existed.
			this.authError = null
			return this.externalLogIn({
				token: self.$route.query.token
			})
				.then((token) => {
					this.tryingToLogIn = false
					this.isAuthError = false
					// Redirect to the originally requested page, or to the my lists
					this.$router.push(
						this.$route.query.redirectFrom || { name: 'Minhas listas' }
					)
				})
				.catch((error) => {
					this.tryingToLogIn = false
					this.authError = error.response ? error.response.data.message : ''
					this.isAuthError = true
				})
		},
	},
}
</script>

<template>
	<Layout>

	</Layout>
</template>

<style lang="scss" module></style>
